import router from './routers'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken } from '@/utils/auth' // getToken from cookie
NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/login', '/', '/agentBusiness', '/apiDoc/describe', '/apiDoc/submit/interFace',
  '/apiDoc/callback/interFace', '/apiDoc/query/interFace', '/apiDoc/query/money', '/apiDoc/product/code',
  '/apiDoc/province/code', '/apiDoc/appendix', '/contactUs', '/login', '/regiest', '/regiestSucc', '/agreement',
  '/findPassIndex', '/findPass/second']// no redirect whitelist

router.beforeEach((to, from, next) => { // beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title + ' - ' + '速代充商户系统'
  }
  NProgress.start()
  if (getToken()) {
    next()
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
    }
    NProgress.done()
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/router/index.js